/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface ResultFile
 */
export interface ResultFile {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  created: Date;
  /**
   *
   */
  file?: FileReadOnly;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the ResultFile interface.
 */
export function instanceOfResultFile(value: object): value is ResultFile {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  if (!("created" in value) || value["created"] === undefined) return false;
  return true;
}

export function ResultFileFromJSON(json: any): ResultFile {
  return ResultFileFromJSONTyped(json, false);
}

export function ResultFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultFile {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    filename: json["filename"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    created: json["created"] == null ? json["created"] : parseDateTime(json["created"]),
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function ResultFileToJSON(json: any): ResultFile {
  return ResultFileToJSONTyped(json, false);
}

export function ResultFileToJSONTyped(
  value?: Omit<ResultFile, "url" | "simulation" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    description: value["description"],
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    file: FileReadOnlyToJSON(value["file"]),
  };
}
